var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDescription)?_c('support-shortend-message-cell',{attrs:{"content":_vm.model.payload || ''}}):(_vm.content)?_c('media-cell',{attrs:{"model":_vm.content,"content":_vm.content.url}}):_c('td')}
var staticRenderFns = []

export { render, staticRenderFns }